import React, { useRef } from 'react';
import { Images } from '../../Atoms';
import './style.css';
import appScreen from '../../Assets/home/appsScreen-c.webp';
import appstore from '../../Assets/shared/app_link_apple.svg';
import playstore from '../../Assets/shared/app_link_playstore.svg';
import { Button } from '../../Atoms';
import { Fade } from 'react-awesome-reveal';
import { useNavigate } from 'react-router-dom';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';

export default function Apps() {
  let AppContainer = useRef(null);
  const navigate = useNavigate();

  return (
    <section
      ref={AppContainer}
      className="appcontainer relative blade-margin-top bg-grey blade-padding-top"
    >
      <div className="containers  mx-auto flex flex-col justify-center items-center">
        {/* <Fade bottom> */}
          <h3 className="text-center font-gilroy">
            It’s <span className="font-bold pr-2">breathtakingly</span>
            <br className="block sm:hidden" />
            intuitive!
          </h3>
          <h5 className="mt-6 text-center max-w-3xl mx-auto leading-normal sm:leading-9 font-poppins">
            A true EV companion! Locate, navigate, and reserve EV Charging
            Stations with VerdeMobility's EV Life Mobile App
          </h5>
        {/* </Fade> */}
        <div className="lg:my-12 my-5">
          <div
            className='mt-5'
            onClick={() => {
              navigate('/mobile-app')
            }}
          >
            <button
              className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
            >
              <span className="flex justify-center items-center">
                <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
              </span>
              Discover the app
            </button>
          </div>
        </div>
        <div className="">
          <Images
            className="xl:mt-10 h-56 sm:h-auto"
            imgClassname="object-cover sm:object-contain xxl:w-full md:w-10/12 w-full"
            alt="app screen"
            src={appScreen}
          />
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-fit  flex justify-center md:p-10 bg-gradient-to-t from-white">
        {/* <Fade bottom> */}
          <a
            href="https://apps.apple.com/in/app/verdemobility/id1622189313"
            className="w-full max-w-[200px] md:min-w-[150px]"
            rel="noreferrer"
            target="_blank"
          >
            <span className="sr-only">Download IOS app</span>
            <img
              loading="lazy"
              src={appstore}
              className="p-2 "
              alt="ios icon"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.verdemobility.ev.charger"
            className="w-full max-w-[200px] md:min-w-[150px]"
            target="_blank"
            rel="noreferrer"
          >
            <span className="sr-only">Download Android app</span>

            <img
              loading="lazy"
              src={playstore}
              className="p-2 "
              alt="android icon"
            />
          </a>
        {/* </Fade> */}
      </div>
    </section>
  );
}
